module.exports = __webpack_public_path__ + "static/3-cc468f83d877de6f90dd388cca30bc03.png";